import { forwardRef } from 'react';
import { TCategory } from '@api/io/categories.io';
import { Link } from 'react-router-dom';
import { cn } from '@fe-learner-common';
import { useSelectedCategoryParam } from '@routes/catalog/components/Categories/useSelectedCategoryParam';

export const CategoryLinkItem = forwardRef<
  HTMLAnchorElement,
  {
    className?: string;
    category: TCategory;
  }
>(({ className, category, ...rest }, ref) => {
  const selectedCategoryId = useSelectedCategoryParam();

  return (
    <Link
      ref={ref}
      {...(rest || {})}
      className={cn(
        'lf:l-btn lf:l-btn-md lf:l-btn-secondary',
        { 'lf:bg-neutral-300': category.id === selectedCategoryId },
        className,
      )}
      to={{
        pathname: '/',
        search: `?categories=${category.id}`,
      }}
    >
      {category.name}
    </Link>
  );
});

CategoryLinkItem.displayName = 'CategoryLinkItem';
